export * from "./HospitalsData.async";
